export default {
  SERVICE_DATA: 'SERVICE_DATA',
  SERVICE_INCLUDED: 'SERVICE_INCLUDED',
  SERVICE_DELIVERY_SERVICES: 'SERVICE_DELIVERY_SERVICES',
  SERVICE_PAYMENT_SERVICES: 'SERVICE_PAYMENT_SERVICES',
  SERVICE_DELIVERY_SERVICES_FORMATTED: 'SERVICE_DELIVERY_SERVICES_FORMATTED',
  SERVICE_PAYMENT_SERVICES_FORMATTED: 'SERVICE_PAYMENT_SERVICES_FORMATTED',
  SERVICE_SELECTED_PAYMENT_SERVICES_FORMATTED: 'SERVICE_SELECTED_PAYMENT_SERVICES_FORMATTED',
  SERVICE_SELECTED_DELIVERY_SERVICES_FORMATTED: 'SERVICE_SELECTED_DELIVERY_SERVICES_FORMATTED',
  SERVICE_DELIVERY_SERVICE_BASKET: 'SERVICE_DELIVERY_SERVICE_BASKET',
  SERVICE_PAYMENT_SERVICE_BASKET: 'SERVICE_PAYMENT_SERVICE_BASKET',
  SERVICE_DELIVERY_SERVICE_CODE: 'SERVICE_DELIVERY_SERVICE_CODE',
  SERVICE_PAYMENT_SERVICE_CODE: 'SERVICE_PAYMENT_SERVICE_CODE',
}
